import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import api from 'api';
import Util from 'utility';
import BuildMetadata from 'metadata.json';

function Support() {
    const data = useSelector(state => state);
    const [formMessage, setFormMessage] = useState('');

    useEffect(() => {
        Util.setPageTitle('Podpora');
    }, []);

    const sendMessage = (e) => {
        e.preventDefault();
        if (formMessage === '') {
            alert("Napište nejprve text zprávy.");
            return;
        }
        api('account/send-message', { post: true, data: { message: formMessage } }).then(() => {
            setFormMessage('');
            alert("Zpráva odeslána, děkujeme.");
        });
    };

    let texts = [], n = 1;
    const versions = ['personal', 'profi'];
    versions.forEach(version => {
        const versionHeading = version.charAt(0).toUpperCase() + version.slice(1);
        texts.push(<h2 key={version}>{`ZOFapp ${versionHeading}`}</h2>);
        data.globals.zofManualTexts.forEach(text => {
            if (!text.version || text.version === '') text.version = 'personal';
            if (text.version !== version) return;
            texts.push(
                <div key={n}>
                    <input className="hidden peer" type="checkbox" id={`q${n}`} />
                    <label htmlFor={`q${n}`} className="flex items-center cursor-pointer py-[0.75em] border-b border-[#eee] hover:text-[#26AA52]">
                        <span className="mr-[0.5em]"><i className="far fa-question-circle"></i></span>
                        <h3 className="m-0 font-normal text-[1em]">{text.title}</h3>
                    </label>
                    <div className="hidden peer-checked:block px-[1em] py-[0.75em] bg-[#f9f9f9]">
                        <div dangerouslySetInnerHTML={{ __html: text.body }} />
                    </div>
                </div>
            );
            n++;
        });
    });

    return (
        <div className="w-full flex flex-col">
            <div className="text-center py-[1.25em] pb-[0.75em] bg-[#eff1f7] relative">
                <h1>Nápověda</h1>
            </div>
            <div className="border-t border-[#e0e4eb] flex flex-1 flex-col">
                <div className="max-w-[1180px] mx-auto px-[1em]" style={{paddingTop:'1em'}}>
                    <div className="flex gap-[2em]">
                        <div className="flex-1">
                            {texts}
                        </div>
                        <div className="basis-[300px] shrink-0">
                            <h2>Dejte nám vědět!</h2>
                            <p style={{fontSize:'.9em',color:'#444',margin:'-.5em 0 1em 0'}}>Máte námět na zlepšení nebo chcete nahlásit chybu? Napište nám:</p>
                            <textarea name="message" value={formMessage} onChange={e => setFormMessage(e.target.value)}></textarea>
                            <p>
                                <button onClick={sendMessage}>Odeslat</button>
                            </p>
                        </div>
                        <p style={{margin:'1em 0 0',fontWeight:'bold'}}>Verze aplikace: {BuildMetadata.buildNumber}.{BuildMetadata.buildDate}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Support;
